var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import CheckCircleBrokenSvg from './check-circle-broken.icon.svg';
export const CheckCircleBrokenIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: CheckCircleBrokenSvg }));
_react_refresh_temp_1 = CheckCircleBrokenIcon;
$RefreshReg$(_react_refresh_temp_1, "CheckCircleBrokenIcon");
